import { createAction } from 'utils/redux'

export const updateReportTimePeriod = createAction('UPDATE_REPORT_TIME_PERIOD')
export const updateReportBotStatus = createAction('UPDATE_REPORT_BOT_STATUS')
export const updateReportWidgetStatus = createAction(
  'UPDATE_REPORT_WIDGET_STATUS'
)
export const updateReportAgentsSelected = createAction(
  'UPDATE_REPORT_AGENTS_SELECTED'
)
export const updateInboxSelected = createAction('UPDATE_INBOX_SELECTED')
export const updateTeamSelected = createAction('UPDATE_TEAM_SELECTED')
export const updateClassificationSelected = createAction(
  'UPDATE_CLASSIFICATION_SELECTED'
)
export const updateTeammateEmailSelected = createAction(
  'UPDATE_TEAMMATE_EMAIL_SELECTED'
)
export const updateAutomationPlaybookSelected = createAction(
  'UPDATE_AUTOMATION_PLAYBOOK_SELECTED'
)
export const clearConversationFilters = createAction(
  'CLEAR_CONVERSATION_FILTERS'
)
export const updateWorkspaceSelected = createAction('UPDATE_WORKSPACE_SELECTED')
export const updateWorkspaceAgents = createAction('UPDATE_WORKSPACE_AGENTS')
export const updateCompoundFilter = createAction('UPDATE_COMPOUND_FILTER')
